enum ErrorCodes {
  // Fetch Errors
  FetchVehicleError = 'FVEH-ERR',
  FetchVehicleSpecsError = 'FVES-ERR',
  FetchDealersError = 'FDES-ERR',
  FetchDealerError = 'FDEA-ERR',
  FetchInventoryError = 'FINV-ERR',
  FetchAttributesError = 'FATT-ERR',
  FetchModelOverviewError = 'FMOV-ERR'
}

export default ErrorCodes;
